var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchglass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_6364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1469 19.4398C15.2784 19.4398 19.4383 15.2799 19.4383 10.1484C19.4383 5.01685 15.2784 0.856934 10.1469 0.856934C5.01538 0.856934 0.855469 5.01685 0.855469 10.1484C0.855469 15.2799 5.01538 19.4398 10.1469 19.4398Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1395 23.1424L16.7109 16.7139",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_6364"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchglass);
export default __webpack_public_path__ + "static/media/searchglass.ac6cd24c3a2fbcd9ec9374fefb328590.svg";
export { ForwardRef as ReactComponent };